export const country = [
  { value: 'Deutschland', label: 'Deutschland' },
  { value: 'Österreich', label: 'Österreich' },
  { value: 'Schweiz', label: 'Schweiz' },
  { value: 'Tschechien', label: 'Tschechien' },
  { value: 'Polen', label: 'Polen' },
];